import { CmsObjectWithDefault } from '@components/Cms/types';

export type OtherWaysToSignInFormCmsKey = 'OtherWaysToSignIn';

export const OtherWaysToSignInFormCmsWithDefault: CmsObjectWithDefault<OtherWaysToSignInFormCmsKey> = {
    OtherWaysToSignIn: {
        cmsId: 76948,
        defaultTranslation: 'Other ways to sign in',
    },
};
